export default "__VITE_ASSET__5110b8b6__"